import styled from 'styled-components'

export const Box = styled.div`
  .role {
    min-width: 15%;
  }

  .btn {
    cursor: pointer;
    background-color: transparent;
    padding: var(--button-padding);
    color: var(--gray-600);
    outline: 0;
    transition: background-color var(--timing) var(--easing),
      border-color var(--timing) var(--easing), box-shadow var(--timing) var(--easing),
      color var(--timing) var(--easing);
    user-select: none;
    vertical-align: middle;
    white-space: nowrap;

    &:hover,
    &:focus,
    &:active {
      outline: 0;
    }

    &:focus:active {
      border-color: var(--gray-400);
    }

    &[disabled] {
      cursor: not-allowed;
    }

    @media screen and (prefers-reduced-motion: reduce) {
      transition: none;
    }
  }

  .cursorDefault {
    cursor: initial;
  }

  .rotate {
    transition: all var(--timing) var(--easing);
  }

  .active {
    transform: rotate(180deg);
  }
`
